import br from 'core/translations/br'

export default br
